import React from 'react';
import './index.scss';

const randoms = [
  { paddingTop: '30px' },
  { paddingTop: '40px' },
  { paddingBottom: '30px' },
  { paddingBottom: '40px' },
];

const CardHeader = ({
  title,
  content,
  updated,
  randomNum,
  className,
  onClick,
  onDelete,
  onEdit,
  isLogged,
}) => {
  return (
    <div className={`randomCard ${className}`} onClick={onClick}>
      <div className="card card-blue-border">
        {isLogged && (
          <div className="card-buttons">
            <span className="fa fa-pen card-btn" onClick={onEdit} />
            <span className="fa fa-trash card-btn" onClick={onDelete} />
          </div>
        )}
        <div className="card-body">
          <p className="card-text">{content}</p>
          <p className="card-text">
            <small className="text-muted">{updated}</small>
          </p>
        </div>
        <div className="card-header" style={{ textAlign: 'right' }}>
          <h5 className="card-title" style={randoms[randomNum]}>
            {title}
          </h5>
        </div>
      </div>
    </div>
  );
};

export default CardHeader;
